import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import { serializeRtkQueryError } from 'util/rtkQueryError';

export const NOTIFICATION_INBOX_TAG = 'NotificationInbox';
const enhanced = rtkAPI.enhanceEndpoints({
  addTagTypes: [NOTIFICATION_INBOX_TAG]
});
const operation = fn => async () => {
  try {
    return { data: await fn() };
  } catch (error) {
    return { error: serializeRtkQueryError(error) };
  }
};
export const notificationInboxApi = enhanced.injectEndpoints({
  endpoints: build => ({
    getNotificationInbox: build.query({
      // userGuid partitions the client cache; the server derives ownership from the login token.
      queryFn: args => operation(() => api.NotificationInbox.list(args))(),
      providesTags: [NOTIFICATION_INBOX_TAG]
    }),
    markInboxRead: build.mutation({
      queryFn: guid => operation(() => api.NotificationInbox.markRead(guid))(),
      invalidatesTags: [NOTIFICATION_INBOX_TAG]
    }),
    markAllInboxRead: build.mutation({
      queryFn: () => operation(() => api.NotificationInbox.markAllRead())(),
      invalidatesTags: [NOTIFICATION_INBOX_TAG]
    })
  })
});
export const {
  useGetNotificationInboxQuery,
  useMarkInboxReadMutation,
  useMarkAllInboxReadMutation
} = notificationInboxApi;
